import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

import CloseIcon from "../../../assets/icons/close.svg";
import APIVariables from "../../../services/api-variables";
import { ReactComponent as ArrowNextWhite } from "../../../assets/icons/arrowNextWhite.svg";
import { ReactComponent as Undo } from "../../../assets/icons/undo.svg";

import StyledRegister from "../../authentication/StyledRegister";
import { handleCatch, isObject, validateEmail } from "../../../shared/helpers";
import { App } from "../../../routes/Constants";
import QuitModal from "../../common/Modal/QuitModal";
import axios from "axios";
import LocalStorage from "../../../shared/localStorage";
import { registrationCategory } from "../../../constants/register.constants";
import Footer from "../../common/Footer/Footer";
import Modal from "react-modal";
import SuccessRegister from "../../../assets/icons/checkRegister.svg";
import { errorMessages } from "../../../constants/errorMessages.constants";

const NurseAdd = () => {
  let customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      width: "37%",
    },
  };

  const history = useHistory();

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [nurseForm, setNurseForm] = useState({});
  const [userCreated, setUserCreated] = useState(false);

  const [quitModalIsOpen, setIsOpenQuit] = useState(false);

  const getLocalStorage = localStorage.getItem(LocalStorage.USER_IRELAND);
  const parseLocalStorage = JSON.parse(getLocalStorage);

  const [errorMessage, setErrorMessage] = useState("");
  const [disableSaveButton, setDisableSaveButton] = useState(false);

  const [userDetails, setUserDetais] = useState();

  useEffect(() => {
    getProfile();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getProfile = () => {
    const user = {
      isLoggedIn: true,
      token: parseLocalStorage.token,
      ...parseLocalStorage,
      ...(parseLocalStorage.user_type === registrationCategory.PRESCRIBER && {
        ...parseLocalStorage.prescriber,
        hospital: parseLocalStorage.prescriber.hospital.id,
      }),
    };

    setUserDetais(user);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    let filterValue = value;

    const nameRegex = /[^a-zA-Z -]/g;

    if (name === "first_name" || name === "last_name") {
      if (value === "" || nameRegex.test(e.target.value)) {
        filterValue = filterValue.replace(nameRegex, "");
      }
    }

    if (
      name === "email" &&
      (errorMessage || []).find((element) => element?.email)
    ) {
      setErrorMessage(
        (errorMessage || []).filter((element) => !element?.email)
      );
    }

    setNurseForm((prevState) => ({
      ...prevState,
      [name]: filterValue,
    }));
  };

  function closeForm() {
    setIsOpenQuit(true);
  }

  function closeModalQuit() {
    setIsOpenQuit(false);
  }

  function quitModal() {
    history.push(App.DASHBOARD);
  }

  const nextPage = async () => {
    setIsSubmitting(false);
    setErrorMessage("");
    if (areAllFields) {
      const getLocalStorage = localStorage.getItem(LocalStorage.USER_IRELAND);
      const parseLocalStorage = JSON.parse(getLocalStorage);

      let copyOfNurseForm = Object.assign({}, nurseForm);
      setDisableSaveButton(true);

      const res = await axios
        .post(
          process.env.REACT_APP_BASE_URL +
            APIVariables.USERS_SIGNUP_CONNECTED_NURSES,
          copyOfNurseForm,
          {
            headers: {
              Authorization: parseLocalStorage.token,
            },
          }
        )
        .catch(function (error) {
          handleCatch(error);

          const errors = error?.response?.data;
          if (typeof errors === "string") {
            setErrorMessage([errorMessages.INTERNAL_SERVER_ERROR]);
          } else {
            const errorsArray = [];
            if (!!errors) {
              Object.keys(errors).forEach((key) => {
                if (isObject(errors[key])) {
                  Object.keys(errors[key]).forEach((secondKey) => {
                    errorsArray.push(key + " - " + errors[key][secondKey][0]);
                  });
                } else {
                  errorsArray.push(errors[key]);
                }
              });
              setErrorMessage(errorsArray);
            } else {
              setErrorMessage([error.message]);
            }
            setErrorMessage(errorsArray);
          }
        });

      setDisableSaveButton(false);

      if (res?.status === 200) {
        setUserCreated(true);
      }
    } else {
      setIsSubmitting(true);
    }
  };

  const continueButton = () => {
    setUserCreated(false);
    history.push(App.NURSES);
  };

  const validateForm = ({
    first_name = "",
    last_name = "",
    job_title = "",
    email = "",
  }) => ({
    first_name: {
      isValid: first_name.trim().length > 0,
    },
    last_name: {
      isValid: last_name.trim().length > 0,
    },
    job_title: {
      isValid: job_title.trim().length > 0,
    },
    email: {
      isValid: email.trim().length > 0,
    },
    emailValid: {
      isValid: validateEmail(email),
    },
  });

  let areAllFields;

  const { first_name, last_name, job_title, email } = nurseForm;

  const validateScreenFields = validateForm({
    first_name,
    last_name,
    job_title,
    email,
  });

  areAllFields = Object.values(validateScreenFields).every((field) => {
    return field.isValid;
  });

  const isEmailInvalid = errorMessage && errorMessage[0]?.email;

  const undoChanges = () => {
    setNurseForm({});
  };

  return (
    <React.Fragment>
      <StyledRegister>
        <div className="layout-modal">
          <div className="close-icon" onClick={closeForm}>
            <img src={CloseIcon} alt="Close Icon" />
          </div>
          <div className="font-size-18 aqua-deep">Step 1/1</div>
          <h1 className="select-category-txt">Nurse Registration Form</h1>
          <hr className="green-hr" />

          <h2 className="title-details">Nurse Details</h2>

          <div className="container mb-5">
            <div className="row">
              <div className="col">
                <label
                  className={
                    isSubmitting && !validateScreenFields.first_name.isValid
                      ? "error-text-color"
                      : ""
                  }
                >
                  Nurse First Name*
                </label>
                <input
                  type="text"
                  onChange={handleChange}
                  name="first_name"
                  maxLength={30}
                  value={nurseForm.first_name ?? ""}
                  className={
                    isSubmitting && !validateScreenFields.first_name.isValid
                      ? "error"
                      : ""
                  }
                />
                {isSubmitting && !validateScreenFields.first_name?.isValid && (
                  <span className="required-text">Required</span>
                )}
              </div>
              <div className="col">
                <label
                  className={
                    isSubmitting && !validateScreenFields.last_name.isValid
                      ? "error-text-color"
                      : ""
                  }
                >
                  Nurse Last Name*
                </label>
                <input
                  type="text"
                  onChange={handleChange}
                  name="last_name"
                  value={nurseForm.last_name ?? ""}
                  maxLength={30}
                  className={
                    isSubmitting && !validateScreenFields.last_name.isValid
                      ? "error"
                      : ""
                  }
                />
                {isSubmitting && !validateScreenFields.last_name?.isValid && (
                  <span className="required-text">Required</span>
                )}
              </div>
            </div>
            <div className="row">
              <div className="col">
                <label
                  className={
                    isSubmitting && !validateScreenFields.job_title.isValid
                      ? "error-text-color"
                      : ""
                  }
                >
                  Job Title*
                </label>
                <input
                  type="text"
                  onChange={handleChange}
                  name="job_title"
                  value={nurseForm.job_title ?? ""}
                  maxLength={30}
                  className={
                    isSubmitting && !validateScreenFields.job_title.isValid
                      ? "error"
                      : ""
                  }
                />
                {isSubmitting && !validateScreenFields.job_title?.isValid && (
                  <span className="required-text">Required</span>
                )}
              </div>
              <div className="col">
                <label>Hospital Name:</label>
                <input
                  type="text"
                  name="hospital_label"
                  value={userDetails?.prescriber?.hospital?.name || ""}
                  disabled
                />
              </div>
            </div>
            <div className="row">
              <div className="col">
                <label>Hospital Address*</label>
                <input
                  type="text"
                  name="hospital_address"
                  value={
                    userDetails?.prescriber?.hospital?.address?.full_address ||
                    ""
                  }
                  disabled
                />
              </div>
              <div className="col">
                <label
                  className={
                    (isSubmitting && !validateScreenFields.email.isValid) ||
                    (isSubmitting &&
                      !validateScreenFields.emailValid.isValid &&
                      validateScreenFields.email.isValid)
                      ? "error-text-color"
                      : ""
                  }
                >
                  Email Address: (A link will be sent to verify your email
                  address)*
                </label>
                <input
                  type="text"
                  onChange={handleChange}
                  name="email"
                  value={nurseForm.email ?? ""}
                  maxLength={50}
                  className={
                    (isSubmitting && !validateScreenFields.email.isValid) ||
                    (isSubmitting &&
                      !validateScreenFields.emailValid.isValid &&
                      validateScreenFields.email.isValid)
                      ? "error"
                      : ""
                  }
                />
                {isSubmitting && !validateScreenFields.email?.isValid && (
                  <span className="required-text">Required</span>
                )}
                {isSubmitting &&
                  !validateScreenFields.emailValid.isValid &&
                  validateScreenFields.email.isValid && (
                    <span className="required-text">Invalid Email</span>
                  )}
                {isEmailInvalid && (
                  <span className="required-text">{isEmailInvalid}</span>
                )}
              </div>
            </div>
            <div className="row">
              <div className="row">
                <div className="col important-register-nurse">
                  IMPORTANT: Connected Nurses remain connected for up to 12
                  months from their original registration date
                </div>
              </div>
            </div>

            {(errorMessage || []).map((item) => (
              <div className="red-text">{item}</div>
            ))}
          </div>

          <div className="wrapper-buttons-select-type">
            <label>*symbol indicating a mandatory field</label>
            <div>
              <button
                className="undo-primary-button"
                onClick={() => undoChanges()}
              >
                <Undo /> Undo Changes
              </button>
              <button
                className="primary-button"
                onClick={nextPage}
                disabled={disableSaveButton}
              >
                Save <ArrowNextWhite />
              </button>
            </div>
          </div>
        </div>

        {quitModalIsOpen && (
          <QuitModal
            quitModalIsOpen={quitModalIsOpen}
            closeModalQuit={closeModalQuit}
            quitModal={quitModal}
            description="Are you sure you want to cancel filling out this form? All progress will be lost and you will need to start again."
          />
        )}
        <Modal
          isOpen={userCreated}
          style={customStyles}
          contentLabel="Register Modal"
          overlayClassName="overlay-modal"
          shouldCloseOnOverlayClick={false} // add this to prevent outside click to prevent modal close
        >
          <div className="wrapper-modal">
            <div>
              <img src={SuccessRegister} alt="success" />
            </div>
            <div className="main-text" style={{ marginTop: "20px" }}>
              Connected Nurse Added
            </div>
            <div className="second-text" style={{ marginBottom: "-30px" }}>
              An email has been sent to this Connected Nurse. This gives the
              Connected Nurse access to your patient list.
            </div>
          </div>
          <div className="wrapper-buttons">
            <button className="green-button" onClick={continueButton}>
              Return <ArrowNextWhite />
            </button>
          </div>
        </Modal>
      </StyledRegister>
      <Footer />
    </React.Fragment>
  );
};
export default NurseAdd;
